import { useState } from "react";
import { GetProps, View, useTheme } from "tamagui";

import { Button } from "./Button";

const ChatIcon = ({
  active,
  Icon,
  onPress,
  ariaLabel,
  disableWhenActive = true,
  ...props
}: {
  active: boolean;
  Icon: React.ComponentType<{ size: number; color: string }>;
  onPress: () => void;
  ariaLabel: string;
  disableWhenActive?: boolean;
} & GetProps<typeof Button.Wrapper>) => {
  const [isPressed, setIsPressed] = useState(false);
  const theme = useTheme();
  const colorToken = active || isPressed ? "$fillPrimary" : "$iconBase";
  const color = theme[colorToken]?.get();
  return (
    <Button.Wrapper
      title={ariaLabel}
      alignItems="center"
      padding="$75"
      disabled={disableWhenActive && active}
      borderRadius="$100"
      mode="chatIcon"
      aria-label={ariaLabel}
      onPress={onPress}
      onPressIn={() => setIsPressed(true)}
      onPressOut={() => setIsPressed(false)}
      hoverStyle={{ backgroundColor: "$navHover" }}
      focusVisibleStyle={{
        outlineWidth: 2,
        outlineOffset: 2,
        outlineColor: "$a11yBlue",
        outlineStyle: "solid",
      }}
      {...props}
    >
      <View height={18} width={18}>
        <Icon size={18} color={color} />
      </View>
    </Button.Wrapper>
  );
};

export default ChatIcon;
